var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',{attrs:{"fill":"none","stroke":"currentColor"}},[_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }